export const disableBodyScroll = (isDisabled: boolean): void => {
  isDisabled
    ? document.body.classList.add('scroll-lock')
    : document.body.classList.remove('scroll-lock');
};
